import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import FiisPageLayout from "components/company/v3/layouts/FiisPageLayout";
import { CompanyAboutTabEnum } from "components/company/v3/menu/enums";
import FiisAboutBox from "components/company/v3/realestatefunds/boxes/FiisAboutBox";
import FiisCardsContent from "components/company/v3/realestatefunds/contents/about/FiisCardsContent";
import FiiIssuerSeo from "components/company/v3/seo/FiiIssuerSeo";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { useIntl } from "react-intl";
import { format } from "util";

interface FiisAboutPageProps {
  tickerSymbol: string | null;
}

const FiisAboutPage: NextPage<FiisAboutPageProps> = function FiisAboutPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyAboutTabEnum>(Object.values(CompanyAboutTabEnum)).withDefault(CompanyAboutTabEnum.ABOUT),
  );

  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <FiisPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="FIIs" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <FiisAboutBox
          key={format("about/%s/%s", normalizedTickerSymbol, tab)}
          tickerSymbol={normalizedTickerSymbol}
          tab={tab}
          onChangeTab={setTab}
        >
          <FiiIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Sobre",
              id: "nicxtA",
              description: "Título da página - SEO",
            })}
          />
          <FiisCardsContent />
        </FiisAboutBox>
      </WrapperAmplitudeCompanyTab>
    </FiisPageLayout>
  );
};

FiisAboutPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default FiisAboutPage;
